import {
  ActionIcon,
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Image,
  Paper,
  Rating,
  Text,
  useMantineTheme,
  Loader,
  Breadcrumbs,
  createStyles,
  Badge,
  Transition,
  Group,
  Divider,
  ThemeIcon,
  Tabs,
  Table,
  Modal,
} from "@mantine/core";
import { Carousel } from "@mantine/carousel";

import {
  IconCash,
  IconChevronLeft,
  IconChevronRight,
  IconMinus,
  IconPlus,
  IconShoppingCartPlus,
  IconShare,
  IconLock,
  IconAlignJustified,
  IconStars,
  IconList,
  IconTruckDelivery,
  IconClock,
  IconInfoCircle,
} from "@tabler/icons-react";

import { useEffect, useState, useContext, useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mantine/hooks";
import { api } from "../services/master.service";
import { CartContext } from "../App";
import { is_mobile_view } from "../config";
import { showSuccessToast, showErrorToast } from "../utilities/Toast";

import { Rate, Input } from "antd";
import Textarea from "antd/lib/input/TextArea";
import { motion, AnimatePresence } from "framer-motion";

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: 180,
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
    minHeight: '100vh',
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      paddingTop: 150,
    },
  },

  imageCard: {
    borderRadius: theme.radius.lg,
    overflow: 'hidden',
    backgroundColor: theme.white,
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      borderRadius: 0,
    },
  },

  infoCard: {
    padding: theme.spacing.xl,
    borderRadius: theme.radius.lg,
    backgroundColor: theme.white,
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      padding: theme.spacing.md,
      borderRadius: 0,
      borderTop: `1px solid ${theme.colors.gray[2]}`,
    },
  },

  priceSection: {
    padding: theme.spacing.md,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.brand[0],
    border: `1px solid ${theme.colors.brand[2]}`,
  },

  cartRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 24,
  },

  qtySelector: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
    borderRadius: 40,
    padding: '4px 8px',
    border: `1.5px solid ${theme.colors.gray[3]}`,
    gap: 4,
  },

  qtyBtn: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: 'none',
    backgroundColor: theme.white,
    boxShadow: theme.shadows.xs,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: theme.colors.brand[0],
      boxShadow: theme.shadows.sm,
    },
    '&:disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },

  addToCartBtn: {
    flex: 1,
    height: 52,
    borderRadius: 14,
    fontWeight: 700,
    fontSize: 16,
    background: `linear-gradient(135deg, ${theme.colors.brand[6]}, ${theme.colors.brand[8]})`,
    border: 'none',
    color: theme.white,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    boxShadow: `0 4px 18px ${theme.colors.brand[3]}88`,
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: `0 8px 24px ${theme.colors.brand[4]}99`,
    },
    '&:disabled': {
      background: theme.colors.gray[4],
      boxShadow: 'none',
      cursor: 'not-allowed',
      transform: 'none',
    },
  },
}));



export default function BundlesProduct() {
  const { classes, cx } = useStyles();
  const theme = useMantineTheme();
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const { id } = useParams();

  const [bundle, setBundle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [stars, setStars] = useState(2.5);
  const [reviewTitle, setReviewTitle] = useState("");
  const [reviewText, setReviewText] = useState("");
  const [bundleSpecifications, setBundleSpecifications] = useState([]);

  const navigate = useNavigate();
  const { setCartItemCount } = useContext(CartContext);

  const addBundleToCart = () => {
    api
      .add_bundle_to_cart(bundle.id)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const productRows = data.cartitem?.filter(item => item.bundle === null).length ?? 0;
          const bundleRows = data.cart_bundles?.length ?? 0;
          setCartItemCount(productRows + bundleRows);

          showSuccessToast({
            title: "Success",
            message: "Bundle added to cart successfully",
          });
        } else if (res.data.code === 401) {
          navigate("/login");
        } else {
          showErrorToast({
            title: "Error",
            message: res.data.message || "Unable to add bundle",
          });
        }
      })
      .catch(() => {
        showErrorToast({
          title: "Error",
          message: "Server error",
        });
      });
  };

  useEffect(() => {
    api.get_bundles().then((res) => {
      if (res.data.success) {
        const found = res.data.data.find(
          (b) => b.id === parseInt(id)
        );

        setBundle(found);

        if (found?.specification) {
          setBundleSpecifications(JSON.parse(found.specification));
        }
      }
      setLoading(false);
    });
  }, [id]);

  if (loading || !bundle) {
    return (
      <Box
        h={400}
        display="flex"
        style={{ alignItems: "center", justifyContent: "center" }}
      >
        <Loader />
      </Box>
    );
  }

  const items = bundle.products || [];
  const activeItem = items[activeIndex];
  const outOfStock = bundle?.bundle_count <= 0;

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className={classes.root}
    >
      <Container size="xl" px={isMobileScreen ? 0 : 'md'}>
        <Box mb={24} px={isMobileScreen ? 'md' : 0}>
          <Breadcrumbs separator="/">
            <Link to="/" style={{ textDecoration: 'none', color: theme.colors.gray[6], fontSize: 14 }}>Home</Link>
            <Link to="/categories" style={{ textDecoration: 'none', color: theme.colors.gray[6], fontSize: 14 }}>Categories</Link>
            <Link to="/bundles" style={{ textDecoration: 'none', color: theme.colors.gray[6], fontSize: 14 }}>Bundles</Link>
            <Text size={14} color="dimmed" lineClamp={1}>{bundle.name}</Text>
          </Breadcrumbs>
        </Box>

        <Grid gutter={isMobileScreen ? 0 : 'xl'}>
          {/* Image Section */}
          <Grid.Col sm={6}>
            <Paper className={classes.imageCard}>
              <Box pos="relative">
                <Carousel 
                  withIndicators 
                  height={isMobileScreen ? 400 : 500} 
                  styles={{ indicator: { backgroundColor: theme.colors.brand[5] } }}
                  onSlideChange={(index) => setActiveIndex(index)}
                >
                  {items.map((item) => (
                    <Carousel.Slide key={item.id}>
                      <Image src={item.thumbnail} height={isMobileScreen ? 350 : 450} fit="contain" p="md" />
                    </Carousel.Slide>
                  ))}
                </Carousel>
              </Box>
            </Paper>
          </Grid.Col>

          {/* Info Section */}
          <Grid.Col sm={6}>
            <Paper className={classes.infoCard}>
              <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.1 }}>
                <Flex justify="space-between" align="flex-start">
                  <Box flex={1}>
                    <Text size="xs" color="brand.7" fw={700} transform="uppercase" mb={4}>
                      Bundle Product
                    </Text>
                    <Text fw={700} size={isMobileScreen ? 24 : 32} mb={8} lh={1.2}>
                      {activeItem?.title}
                    </Text>
                    <Group spacing="xs" mb={16}>
                      <Rating value={4} readOnly size="xs" />
                      <Text size="xs" color="dimmed">(4 reviews)</Text>
                    </Group>
                  </Box>
                  <ActionIcon size="xl" radius="xl" variant="light" color="gray">
                    <IconShare size={20} />
                  </ActionIcon>
                </Flex>

                <Badge 
                  leftSection={<IconInfoCircle size={12} />} 
                  color="blue"
                  variant="filled"
                  mb={20}
                  size="lg"
                >
                  Includes {activeItem?.bundle_quantity} unit(s) in this bundle
                </Badge>

                <Text color="dimmed" size="sm" mb={24} lineClamp={3}>
                  {activeItem?.description || "Best quality product"}
                </Text>

                <Box className={classes.priceSection}>
                  <Flex align="baseline" gap="md">
                    <Text fw={800} size={28} color="brand.8">₹{activeItem?.bundle_price}</Text>
                    <Text strikethrough size="md" color="red.6" opacity={0.8}>₹{activeItem?.mrp || (activeItem?.bundle_price * 1.2).toFixed(2)}</Text>
                    <Badge color="red" variant="filled">
                      Bundle Offer
                    </Badge>
                  </Flex>
                </Box>

                <Grid mt={30} gutter="md">
                  <Grid.Col span={6}>
                    <Flex align="center" gap="sm">
                      <ThemeIcon variant="light" color="blue" radius="md">
                        <IconCash size={18} />
                      </ThemeIcon>
                      <Box>
                        <Text size="xs" fw={700}>COD</Text>
                        <Text size="xs" color="dimmed">Available</Text>
                      </Box>
                    </Flex>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Flex align="center" gap="sm">
                      <ThemeIcon variant="light" color="teal" radius="md">
                        <IconTruckDelivery size={18} />
                      </ThemeIcon>
                      <Box>
                        <Text size="xs" fw={700}>Delivery</Text>
                        <Text size="xs" color="dimmed">1-2 Days</Text>
                      </Box>
                    </Flex>
                  </Grid.Col>
                </Grid>

                <div className={classes.cartRow}>
                  <div className={classes.qtySelector}>
                    <button
                      className={classes.qtyBtn}
                      disabled={true} // Quantity is fixed for bundles
                    >
                      <IconMinus size={15} />
                    </button>
                    <Text fw={700} size={18} w={36} align="center" lh={1}>
                      {quantity}
                    </Text>
                    <button
                      className={classes.qtyBtn}
                      disabled={true} // Quantity is fixed for bundles
                    >
                      <IconPlus size={15} />
                    </button>
                  </div>

                   <button
                    className={classes.addToCartBtn}
                    onClick={addBundleToCart}
                    disabled={outOfStock}
                  >
                    <IconShoppingCartPlus size={20} />
                    {outOfStock ? 'Sold Out' : 'Add Bundle to Cart'}
                  </button>
                </div>

                {/* <Box
                  mt={20}
                  bg={theme.colors.gray[0]}
                  p={20}
                  style={{ borderRadius: 6 }}
                >
                  <Flex align="center" justify="center" mb={10}>
                    <IconLock size={16} />
                    <Text ml={6} fw={600} size="sm">
                      Guaranteed Safe & Secure Checkout
                    </Text>
                  </Flex>
                  <Image
                    mx="auto"
                    width={220}
                    src="https://minimog-4437.kxcdn.com/megastore/wp-content/themes/minimog/assets/woocommerce/product-trust-badge.png"
                  />
                </Box> */}
              </motion.div>
            </Paper>
          </Grid.Col>
        </Grid>

        {/* Tabs Section */}
        <Paper shadow="xs" radius="lg" p="xl" mt="xl" mb={50}>
          <Tabs defaultValue="description" variant="pills" color="brand">
            <Tabs.List grow={isMobileScreen}>
              <Tabs.Tab value="description" icon={<IconAlignJustified size={16} />}>Description</Tabs.Tab>
              <Tabs.Tab value="reviews" icon={<IconStars size={16} />}>Reviews ({bundle.bundle_review?.length || 0})</Tabs.Tab>
              <Tabs.Tab value="specs" icon={<IconList size={16} />}>Specifications</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="description" pt="xl">
              <Text lh={1.8} size="sm">{bundle.description || "No description available"}</Text>
            </Tabs.Panel>

            <Tabs.Panel value="reviews" pt="xl">
              <Flex justify="space-between" align="center" mb="xl">
                <Text fw={700}>Bundle Reviews</Text>
                <Button variant="outline" size="xs" onClick={() => setIsModalVisible(true)}>Write a Review</Button>
              </Flex>
              {bundle.bundle_review?.map((rev, i) => (
                <Box key={i} mb="lg" p="md" sx={{ backgroundColor: theme.colors.gray[0], borderRadius: theme.radius.md }}>
                  <Group position="apart" mb={8}>
                    <Rating value={rev.star} readOnly size="xs" />
                    <Text size="xs" color="dimmed">{rev.user}</Text>
                  </Group>
                  <Text fw={600} size="sm" mb={4}>{rev.title}</Text>
                  <Text size="xs" color="gray.7">{rev.description}</Text>
                </Box>
              ))}
            </Tabs.Panel>

            <Tabs.Panel value="specs" pt="xl">
              <Table verticalSpacing="md">
                <tbody>
                  {bundleSpecifications.length > 0 ? (
                    bundleSpecifications.map((s, i) => (
                      <tr key={i}>
                        <td style={{ width: 140 }}><Text fw={700} size="xs" color="dimmed">{s.title}</Text></td>
                        <td><Text size="xs">{s.description}</Text></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2}><Text size="xs" color="dimmed">No specifications available</Text></td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Tabs.Panel>
          </Tabs>
        </Paper>
      </Container>

      <Modal
        opened={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        title="Write a Review"
        centered
        radius="lg"
      >
        <Box p="md">
          <Text size="sm" mb={4}>Rating</Text>
          <Rate allowHalf value={stars} onChange={setStars} />
          <Input placeholder="Review Title" value={reviewTitle} onChange={(e) => setReviewTitle(e.target.value)} style={{ marginTop: 16 }} />
          <Textarea placeholder="Describe your experience" value={reviewText} onChange={(e) => setReviewText(e.target.value)} minRows={4} mt="md" />
          <Button fullWidth mt="xl" radius="md" onClick={() => setIsModalVisible(false)}>Submit Review</Button>
        </Box>
      </Modal>
    </motion.div>
  );
}
